import React from "react";
import Project from "./projetEtp";

export function ProjectPlanned() {
  return <Project status="Planifié" />;
}